export default "__VITE_ASSET__Pirc6akG__"